import { observable, action } from 'mobx'
import Api from '@api/rhinocerosAcademy'
import { RHINOCEROS_ACADEMY_A } from '@constant'

class Store {
  id
  @observable title = ''

  constructor(id, title) {
    this.id = id
    this.title = title
  }

  @observable data = {}
  @action
  getData = async () => {
    const { data, success } = await Api.details({ courseId: this.id })
    if (success) {
      this.data = data || {}
    }
  }

  @action
  gotoPage = id => () => {
    window.location.href = RHINOCEROS_ACADEMY_A + '?id=' + id
  }
}
export default Store
